import React from 'react';
import { useGame } from '../context/GameContext';
import { useDDA } from '../hooks/useDDA';
import { useGameEngine } from '../hooks/useGameEngine';
import { storage } from '../utils/storage';

interface CompletionModalProps {
  onNextLevel: () => void;
  onReplayLevel: () => void;
}

export const CompletionModal: React.FC<CompletionModalProps> = ({
  onNextLevel,
  onReplayLevel,
}) => {
  const { state } = useGame();
  const { calculateScore } = useGameEngine();
  
  const score = calculateScore();
  const accuracy = state.selectedCells.length > 0
    ? ((state.selectedCells.length / (state.selectedCells.length + state.errors)) * 100).toFixed(1)
    : '100.0';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-center mb-6">Level Complete!</h2>
        
        <div className="space-y-4 mb-8">
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Time:</span>
            <span className="font-mono">{state.timeElapsed}s</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Errors:</span>
            <span className="font-mono">{state.errors}</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Accuracy:</span>
            <span className="font-mono">{accuracy}%</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Score:</span>
            <span className="font-mono">{(score * 100).toFixed(1)}</span>
          </div>
        </div>
        
        <div className="flex space-x-4">
          <button
            onClick={onReplayLevel}
            className="flex-1 px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Replay Level
          </button>
          <button
            onClick={onNextLevel}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Next Level
          </button>
        </div>
      </div>
    </div>
  );
};